"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrevious = exports.useScrollPosition = void 0;
const react_1 = require("react");
const isBrowser = typeof window !== `undefined`;
const zeroPosition = { x: 0, y: 0 };
const getClientRect = (element) => element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
const getScrollPosition = () => {
    if (!isBrowser) {
        return zeroPosition;
    }
    const targetPosition = getClientRect(document.body);
    if (!targetPosition) {
        return zeroPosition;
    }
    return { x: targetPosition.left, y: targetPosition.top };
};
const useScrollPosition = (effect, deps, delay) => {
    const position = (0, react_1.useRef)(getScrollPosition());
    let throttleTimeout = null;
    const callBack = () => {
        const currPos = getScrollPosition();
        effect({ prevPos: position.current, currPos });
        position.current = currPos;
        throttleTimeout = null;
    };
    (0, react_1.useLayoutEffect)(() => {
        if (!isBrowser) {
            return undefined;
        }
        const handleScroll = () => {
            if (delay) {
                if (throttleTimeout === null) {
                    throttleTimeout = window.setTimeout(callBack, delay);
                }
            }
            else {
                callBack();
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (throttleTimeout) {
                clearTimeout(throttleTimeout);
            }
        };
    }, deps);
};
exports.useScrollPosition = useScrollPosition;
const usePrevious = (value) => {
    const ref = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};
exports.usePrevious = usePrevious;
//# sourceMappingURL=AlertBanner.helper.js.map